import AddIcon from '@material-ui/icons/LibraryAdd';
import { calculateHeight } from "common/services/util";
import LiveMaterialTable from 'common/components/LiveMaterialTable';
import React from 'react';

const TableInvoiceDetail = (
    {
        data,
        columns,
        onInvoiceItemDelete,
        margins
    }) => {
    return (
        <div>
            <LiveMaterialTable
                title=""
                icons={{
                    'Add': () => <AddIcon fontSize='large' color='primary'></AddIcon>
                }}
                columns={columns}
                data={data}
                options={{
                    maxBodyHeight: calculateHeight(window.innerHeight < 900 ? margins[0] : margins[1]), // 20, 100 - 140, 300
                    toolbarButtonAlignment: 'left',
                    addRowPosition: 'first',
                    search: false,
                    pageSize: 15
                }}
                editable={{
                    onRowDelete: onInvoiceItemDelete
                }}
            />
        </div>
    )
}

export default TableInvoiceDetail
